import LogoutIcon from "@mui/icons-material/Logout";
import { Dashboard, LocalShippingTwoTone } from "@mui/icons-material";
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';



const globalOptions = [];

const headerOptions = {
  logged: [
    {
      title: "Dashboard",
      icon: Dashboard,
      route: "/dashboard",
      roles: ["superadmin", "admin"],
    },
    {
      title: "Pedidos",
      icon: LocalShippingTwoTone,
      route: "/pedidos",
      roles: ["superadmin", "admin"],
    },
    {
      title: "Total de productos",
      icon: LocalGroceryStoreIcon,
      route: "/total-productos",
      roles: ["superadmin", "admin"],
    },
    {
      title: "Cerrar Sesión",
      route: "/logout",
      icon: LogoutIcon,
    },
  ],
  default: [...globalOptions],
};

export default headerOptions;
